"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const password_input_1 = require("@app/component/ui/forms/password-input/password-input");
const request_1 = require("@app/request");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const forms_1 = require("@app/util/forms/forms");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const ResetPassword = () => {
    const dispatch = (0, store_1.useRootDispatch)();
    const token = (0, store_1.useRootSelector)((state) => state.auth);
    const userId = (0, store_1.useRootSelector)((state) => state.me).id;
    const { control, handleSubmit, formState: { isDirty, isSubmitting }, reset, } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
    });
    const validator = (0, forms_1.useValidator)(control);
    const confirmPasswordError = validator('confirmPassword', (confirmPassword, fv) => {
        if (confirmPassword !== fv.newPassword) {
            return (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ACC_SET_PASSWORD_NOT_MATCH'));
        }
    });
    const onSubmitPassword = handleSubmit(async (data) => {
        if (!(0, util_1.isValue)(data.newPassword)) {
            throw new Error('reset-password@onSubmit - new password cannot be undefined');
        }
        if ((0, util_1.isDefined)(confirmPasswordError))
            return;
        await (0, request_1.requestUserUpdate)({
            id: userId,
            data: {
                password: {
                    oldPassword: data.oldPassword || undefined,
                    newPassword: data.newPassword,
                },
            },
        }, token).then(() => {
            reset({
                newPassword: '',
                oldPassword: '',
                confirmPassword: '',
            });
            util_1.notification.success({ message: 'ACC_SET_CHANGE_PASSWORD_SUCCESS' });
        });
        await dispatch((0, ac_1.setModal)(null));
    });
    return (react_1.default.createElement(ui_1.Modal, { size: ui_1.Modal.SIZES.S, headerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            react_1.default.createElement(ui_1.Text, { text: (0, util_1.t)('RESET_PW_TITLE'), type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD })), footerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'end', width: '100%' } },
            react_1.default.createElement(ui_1.Button, { onClick: () => {
                    void dispatch((0, ac_1.setModal)(null));
                } }, (0, util_1.t)('CLOSE')),
            react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', disabled: !isDirty || isSubmitting, onClick: onSubmitPassword }, (0, util_1.t)('SAVE'))) },
        react_1.default.createElement("div", { style: {
                padding: '0.5rem 1rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
            } },
            react_1.default.createElement(password_input_1.PasswordInput, { control: control, name: 'oldPassword', label: (0, util_1.t)('ACC_SET_OLD_PASSWORD') }),
            react_1.default.createElement(password_input_1.PasswordInput, { control: control, name: 'newPassword', label: (0, util_1.t)('ACC_SET_NEW_PASSWORD') }),
            react_1.default.createElement(password_input_1.PasswordInput, { control: control, name: 'confirmPassword', label: (0, util_1.t)('ACC_SET_REPEAT_PASSWORD'), error: confirmPasswordError }))));
};
exports.ResetPassword = ResetPassword;
